import { MovieCard } from "@/components/MovieCard";

export const MovieRail = ({ title, movies, testid }) => {
  if (!movies || movies.length === 0) return null;
  return (
    <section className="mb-10" data-testid={testid}>
      <h2 className="font-heading text-lg md:text-xl font-bold text-white px-4 sm:px-8 mb-4">{title}</h2>
      <div className="rail flex gap-3 sm:gap-4 overflow-x-auto px-4 sm:px-8 pb-2">
        {movies.map((m) => (
          <MovieCard key={m.id} movie={m} />
        ))}
      </div>
    </section>
  );
};
